import { PENDING_SCREEN, STARTED_SCREEN } from 'config/config';
import queryString from 'query-string';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import {
  StatusScreenButton,
  StatusScreenContainer,
  StatusScreenIcon,
  StatusScreenMessage,
  StatusScreenRetryMessage,
  StatusScreenStatus,
  StatusScreenStatusText,
  StatusScreenWrapper,
} from '../statusScreen/StatusScreen.styles';

interface IMatchParams {
  paymentId?: string;
}

type IProps = RouteComponentProps<IMatchParams>;

const { status, statusText, icon, description } = PENDING_SCREEN;
const { retryMessage, buttonText } = STARTED_SCREEN;

const StartedStatusScreen = memo(
  ({
    history,
    match: {
      params: { paymentId },
    },
  }: IProps) => {
    const redirectToPayments = () => {
      const { token } = queryString.parse(window.location.search);
      if (!token || !paymentId) {
        throw new Error('No token or payment id');
      }
      return history.push(`/${paymentId}?token=${token}`);
    };

    return (
      <StatusScreenContainer className="started-status-screen__container">
        <StatusScreenWrapper>
          <StatusScreenStatus className="started-status-screen__status">
            <FormattedMessage id={status} />
          </StatusScreenStatus>
          <StatusScreenStatusText className="started-status-screen__statusText">
            <FormattedMessage id={statusText} />
          </StatusScreenStatusText>
          <StatusScreenIcon className="started-status-screen__icon">
            <img src={icon} alt="icon" />
          </StatusScreenIcon>
          <StatusScreenMessage className="started-status-screen__message">
            <FormattedMessage id={description} />
          </StatusScreenMessage>
          <StatusScreenRetryMessage>
            <FormattedMessage id={retryMessage} />
          </StatusScreenRetryMessage>
          <StatusScreenButton className="started-status-screen__button">
            <button type="button" onClick={redirectToPayments}>
              <FormattedMessage id={buttonText} />
            </button>
          </StatusScreenButton>
        </StatusScreenWrapper>
      </StatusScreenContainer>
    );
  }
);

export default withRouter(StartedStatusScreen);
